<template>
    <div v-if="loading">
        <p class="status-message">Loading...</p>
    </div>
    <div v-if="errored">
        <p id="error-message">An error occurred while loading your magnet. Please scan the QR code again.</p>
        <button id="learnhow" class="mdl-button mdl-js-button mdl-button--raised">
            <router-link :to="{ path: '/about' }" >Learn how it works!</router-link>
        </button> 
    </div>
    <div v-if="!loading && !errored">
        <p class="status-message">Scanned your magnet "{{ magnetID }}"</p>
        <div v-if="exists">
            <ExistingMagnet :magnetIdentification="magnetID" />
        </div>
        <div v-else>
            <NewMagnet :magnetID="magnetID" :magnettypeID="magnetType" />
        </div>
    </div>
</template>

<script>
import ExistingMagnet from '../components/ExistingMagnet.vue';
import NewMagnet from '../components/NewMagnet.vue';

export default {
  name: 'MagnetScan',
  components: {
      ExistingMagnet,
      NewMagnet,
  },
  data () {
      return {
          teststring: null,
          magnetID: null,
          magnetType: null,
          url: null,
          json: null,
          errored: false,
          loading: true,
          exists: false,
      }
  }, 
  mounted: function () {
    this.teststring = this.$route.query.magnetID + this.$route.query.magnettype;
    this.magnetID = this.$route.query.magnetID;
    this.magnetType = this.$route.query.magnettype;

    console.log(this.magnetID)
    console.log(this.magnetType)

    this.url = "https://strapi.levt.online/magnets?magnetID_eq=" + this.magnetID;

    fetch(this.url)
      .then(response => response.json())
      .then(response => {
          this.json = response;
      })
      .catch(error => {
          console.error(error)
          this.errored = true
          this.loading = false
      })
      .finally(() => {

          

          this.exists = this.json !== 'undefined' && this.json.length > 0;
          this.loading = false
          });
  }  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#learnhow {
    margin: 10%;
}
#error-message {
    margin: 5%;
    font-size: 130%;
}
</style>